var _defs, _g, _path, _circle, _text;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSigningProcess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 157.5,
    height: 143.917,
    viewBox: "0 0 157.5 143.917",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.o{fill:#fff;}.b{fill:#f5f9fd;}.c{fill:#d1cdd3;opacity:0.408;}.d,.f{fill:#4d8dff;}.d,.e{opacity:0.3;}.g{fill:#ffad69;}.h{fill:#d88344;}.i{fill:#e5aa33;}.j{fill:#707070;}.k{fill:#ffc84d;}.l,.n{fill:none;}.m{fill:#232323;}.n{stroke:#232323;stroke-linejoin:bevel;stroke-width:0.5px;}.o{font-size:17px;font-family:OpenSans-Semibold, Open Sans;font-weight:600;letter-spacing:0.031em;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(61 -16.784)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M140.248,78.994c-2.234,9.081-8.658,17.35-18.227,23.46a72.963,72.963,0,0,1-10.676,5.586c-13.384,5.843-29.971,9.384-47.239,12.288l-2.955.48a40.817,40.817,0,0,1-7.829.514C25.858,120.5,7.151,91.1,1.333,60.17-3.742,32.633,4.753,1.443,42.785.035,57.066-.479,73.731,4.66,89.2,12.927c1.114.592,2.228,1.207,3.327,1.832h0l.681.391C122.1,31.773,145.695,58.729,140.248,78.994Z",
    transform: "matrix(1, -0.017, 0.017, 1, -46.631, 39.378)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M13.171,8.451c1.679,3.394,2.295,7.694-1.075,9.071C8.328,19.068,2.313,16.58.574,10.915-.55,7.292-.163,2.243,2.989.3,5.562-1.368,11.166,4.3,13.171,8.451Z",
    transform: "translate(-23.645 133.008)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M83.358,71.877v.4c-.3,3.37-3.2,10.556-6.039,16.909.1,2.295.169,4.348.181,6.039v.894h-.35c.085,1.5.193,4.094.278,7.078-10.447,6.317-23.4,10.146-36.874,13.286L38.246,117a23.19,23.19,0,0,1-6.111.556A5.06,5.06,0,0,1,32,116.01c.286-6.809,5.078-14.065,6.208-20.786l-2.742.894c14.654-32.3,6.674-23.129,7.387-34.712h0c.085-1.365.157-2.693.217-4.01-1.751,1.788-2.959,2.9-2.959,2.9L31.76,54.2c-4.578,3.309-8.9,6.232-11.015,7.585-1.751,1.643-4.735,1.884-7.078-1.208C9.875,55.608,4.524,34.774,3.9,31.235a.93.93,0,0,1-.254-.145C2.773,29.882-.27,23.3.019,22.019s1.715-4.046,3.37-4.421c-.193-.592-.411-1.208-.725-2.065-.7-1.908-1.534-3.841-.278-3.623s4.131,7.247,4.626,8.455c.072-.568.145-1.027.145-1.027.386-1.135,2.416-1.739,2.114,0-.35,2.416.5,3.623.459,5.616v.4a1.63,1.63,0,0,1,0,.217.64.64,0,0,1,0,.157v.085a14.7,14.7,0,0,1-1.546,4.239h0c1.317,4.3,7.356,15.544,10.87,21.74,2.15-1.788,4.831-3.913,7.609-6.039l-.242-.4s14.325-13.395,21.74-14.409c.109-.519.181-1.087.254-1.679s.121-1.594.145-2.416c-5.447-.06-5.954-4.07-5.411-9.167l-.858-.217,1.268-3.285v-.242a.954.954,0,0,1-.229-.58c0-.4.109-.737.326-.749a.133.133,0,0,1,.1,0,7.209,7.209,0,0,1,.133-.87c.1-.64.217-1.208.338-1.8a2.536,2.536,0,0,0-.978,0l-.1-.592a3.442,3.442,0,0,1,1.208,0,16.257,16.257,0,0,1,1.92-4.59c-1.739-.121-2.561-.688-1.353-2.089C46.8.5,55.663-.591,60.132.327c1.57.326,2.6.894,2.609,1.739v.242h0a2.645,2.645,0,0,0,1.135-.918l.507.338a3.406,3.406,0,0,1-1.111,1l-.181.1c4.783,3.116-1.981,19.808-2,19.808-.133,2.862-.217,5.689-.205,7.682,4.3.5,7.017,1.751,8.817,3.72,4.831,3.877,12.247,19.784,12.247,19.784l-3.032.8c2.162,6.933,4,13.89,4.529,16.221A4.119,4.119,0,0,1,83.358,71.877Z",
    transform: "translate(-6.645 41.657)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 61.755,
    height: 48.372,
    rx: 24.186,
    transform: "translate(36.63 72.022) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M6.455,47.443A6.309,6.309,0,0,1,0,41.289V6.153A6.309,6.309,0,0,1,6.455,0H57.221a6.309,6.309,0,0,1,6.455,6.153V41.266a6.009,6.009,0,0,1-1.882,4.366,6.618,6.618,0,0,1-4.573,1.811Z",
    transform: "translate(-29.125 26.428)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "e",
    transform: "translate(-18.422 31.803)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 9.701,
    height: 7.575,
    rx: 3.788,
    transform: "translate(9.701 7.575) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 9.701,
    height: 7.575,
    rx: 3.788,
    transform: "translate(23.52 7.575) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 9.701,
    height: 7.575,
    rx: 3.788,
    transform: "translate(37.347 7.575) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 9.701,
    height: 7.575,
    rx: 3.788,
    transform: "translate(51.175 7.575) rotate(180)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "e",
    transform: "translate(-18.422 44.827)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 9.701,
    height: 7.575,
    rx: 3.788,
    transform: "translate(9.701 7.575) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 9.701,
    height: 7.575,
    rx: 3.788,
    transform: "translate(23.52 7.575) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 9.701,
    height: 7.575,
    rx: 3.788,
    transform: "translate(37.347 7.575) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 9.701,
    height: 7.575,
    rx: 3.788,
    transform: "translate(51.175 7.575) rotate(180)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 11.098,
    height: 8.666,
    rx: 4.333,
    transform: "translate(18.143 42.684) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M14.642,0c-.411,2.633-1.208,16.909-.882,20.17S-1.941,24.422.2,20.786s.616-15.7.616-15.7Z",
    transform: "translate(50.504 53.869)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M12.718,0,0,4.65A66.067,66.067,0,0,1,.338,16.644c5.242-2.162,4.082-6.558,4.082-8.926C4.421,5.568,12.73.411,12.718,0Z",
    transform: "translate(51.317 54.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M1.981,0,0,4.227l2.416.978L1.981,0Z",
    transform: "translate(45.29 54.823)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M1.15,11.478C.036,20.242-2.039,27.71,7.817,26.37S19.195,12.42,19.17,10.028C19.013-2.678,3.469-4.49,1.15,11.478Z",
    transform: "translate(46.085 41.945)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M18.189,28.7c-.87-3.877-5.4-20.653-9-28.7L0,1.957S5.93,21.789,9.083,29.193C8.346,33.178,4.626,51.718,2.331,56.9c-1.015,2.416,2.826,3.346,3.756,2.186S17.574,36.717,18.165,30.1v-.4a3.225,3.225,0,0,0,.024-1Z",
    transform: "translate(68.552 83.811)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M6.733,1.829c4.831,3.78,12.307,19.856,12.307,19.856L3.219,25.791S-5.985-8.124,6.733,1.829Z",
    transform: "translate(66.203 73.805)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M45.217-53.875a53.916,53.916,0,0,1-8.334,6.039C26.436-41.519,13.488-37.69.009-34.55a3.068,3.068,0,0,1,0-.471c.435-7.476,10.863-34,12.071-39.421l24.9,18.67,8.165.169C45.145-55.191,45.217-54.611,45.217-53.875Z",
    transform: "translate(35.304 192.676)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M21.435,14.013c9.278.314,15.122-.027,16.717,5.517-.653,44.34-2.406,41.851,5.023,56.948,0,0-27.787,2.017-43.176-.568,6.841-7.45,6.854-18.222,8.138-27.761-4.3-4.738-2.749-8.706-3.211-13.4-.672-6.812,3.173-12,3.211-15.222C8.209,12.875,9.663,13.615,21.435,14.013Z",
    transform: "translate(37.648 61.309)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2.73,4.879.181,1.449A.906.906,0,0,1,.906,0H4.855A.918.918,0,0,1,5.7,1.208L4.324,4.638a.906.906,0,0,1-.725.556l-.145.048H3.448A.893.893,0,0,1,2.73,4.879Z",
    transform: "translate(59.808 73.423)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M1.683.69c0,.4-.109.737-.326.749S.946,1.149.922.75,1.031.025,1.248,0,1.659.291,1.683.69Z",
    transform: "translate(45.757 54.266)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M2.428,1.615A2.247,2.247,0,0,0,.133.637L0,.057A2.85,2.85,0,0,1,2.935,1.265Z",
    transform: "translate(46.461 50.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M-11.45,1.022c-.072,4.384-4.115,12.874-4.586,20.688C-12.014,16.88-4.191,9.67-3.962,5.382-3.636-.512-6.981-.874-11.45,1.022Z",
    transform: "translate(53.684 82.849)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M44.315,32.414,39.68,29.534S26.2,33.96,19.059,39.891c-3.527-6.208-9.554-17.453-10.87-21.74h0a14.494,14.494,0,0,0,1.534-4.227.169.169,0,0,0,0-.085v-.157a1.5,1.5,0,0,0,0-.217v-.411c0-1.945-.809-3.14-.459-5.6.242-1.727-1.727-1.135-2.114,0L6.993,8.464C6.5,7.256,3.515.166,2.38.009s-.423,1.751.278,3.623c.3.833.531,1.486.725,2.065C1.715,6.084.242,8.935.012,10.13S2.8,17.993,3.636,19.2a.93.93,0,0,0,.229.205c.616,3.551,6.039,24.373,9.759,29.35,2.343,3.08,5.338,2.838,7.09,1.208C25.014,47.222,38.227,38.139,44.315,32.414Z",
    transform: "translate(0.798 59.195) rotate(-11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M26.064,17.827C25.581,26.693,7.849,39.914,7.849,39.914L0,26.922S13.1,11.788,26.064,17.827Z",
    transform: "translate(29.673 60.053)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M24.579,10.395C21.924,2.248,17.919-.571,14.068-1.323A12.751,12.751,0,0,0,3.443,1.771C1.153,4.065,1.028,4.953,4.908,7.856c-.192.148-.591.368-.666.6-1.7,8.346,4.986,26.492,5.892,27.193a54.9,54.9,0,0,0,10.45,0c4.214-.38,8.627-4.039,7.929-4.712C28.512,30.935,27.234,18.541,24.579,10.395Z",
    transform: "translate(46.652 42.499)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M.347,2.858C-.015,4.984-.547,7.1,1.446,6.941s2.5-3.466,2.536-4.094C4.152-.536,1.06-1.345.347,2.858Z",
    transform: "translate(50.317 53.076)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M11357.632,589.006s.76-1.614,2.1-.934-1.6,6.153-1.6,6.153,3.406-4.638,4.757-4.27-.524,1.686.487,2.057,4.574-2.845,5.578-2.057-.427,1.786.559,2.057,2.96-3.3,7.851-2.493,2.927.436,2.927.436",
    transform: "translate(-11310 -550)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 12,
    cy: 12,
    r: 12
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "o",
    transform: "translate(8 19)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "?"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSigningProcess);
export default __webpack_public_path__ + "static/media/signing-process.24187f762bef9e11242772e8579569c8.svg";
export { ForwardRef as ReactComponent };